import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isDesktop } from 'react-device-detect';

const ShareRedirect = () => {
  const location = useLocation();

  useEffect(() => {
    // Construct the redirect URI based on the device type
    const redirectURI = isDesktop 
      ? `https://app.ybe.life/qr` 
      : `com.bnc.nfcmatch://shareVibe${location.search}`;

    // Perform the redirect
    window.location.href = redirectURI;
  }, [location.search]);

  // Render a fallback view (in case the redirect is delayed)
  return <div>Redirecting...</div>;
}

export default ShareRedirect;
